import isPlainObject from 'lodash/isPlainObject';

// Recursively mutates all keys of an object
export const convertObject = ({
  mutator,
  param,
}: {
  mutator: (input: any) => any;
  param: any;
}): any => {
  if (isPlainObject(param)) {
    const result: { [key: string]: any } = {};
    Object.entries(param).forEach(([key, value]) => {
      result[mutator(key)] = convertObject({ mutator, param: value });
    });
    return result;
  } else if (Array.isArray(param)) {
    return param.map(value => convertObject({ mutator, param: value }));
  } else {
    return param;
  }
};
